import { component_tool, framework_tool, utils_tool } from '@/tool';
let { Storage } = utils_tool;
import React from 'react';
import * as local_urls from '../../../constants/constants_url';

const urls = global && global.constants && global.constants.urls ? global.constants.urls : local_urls;

let { WizModal,WizButton,WizDataTable} = component_tool;
//配置项
let componentName = 'procdef';

const columns = (e) => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "名称",
      name: "name",
      dataIndex: "name",
      searchItem: {},
      tableItem: {}
    },
    {
      title: "标识Key",
      name: "key",
      dataIndex: "key",
      searchItem: {},
      tableItem: {}
    },
    {
      title: "版本",
      name: "version",
      dataIndex: "version",
      tableItem: {}
    },
    {
      title: "部署ID",
      name: "deploymentId",
      dataIndex: "deploymentId",
      tableItem: {}
    },
    {
      title: "流程图片",
      name: "dgrmResourceName",
      dataIndex: "dgrmResourceName",
      tableItem: {
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton tooltip={text}
                       onClick={() => {
                         /*e.dispatch({
                           type:'procdef/viewResource',
                           payload: {
                             key: 'procdef@viewResource',
                             apiParams: {
                               id:record['id'],
                               deploymentId:record['deploymentId'],
                               dgrmResourceName:record['dgrmResourceName'],
                             }
                           },
                           callback:(response)=>{
                             const blob = new Blob([response]);
                             console.log(blob);
                             const turl = window.URL.createObjectURL(blob);
                             a.href = turl;
                             a.download = record['dgrmResourceName'];
                             document.body.appendChild(a);
                             var evt = document.createEvent("MouseEvents");
                             evt.initEvent("click", true, true);
                             a.dispatchEvent(evt);
                             document.body.removeChild(a);
                           }
                         })*/
                         const uploadUrl = `/api${urls.kUrlViewProcedefResource}?id=${record.id}&deploymentId=${record.deploymentId}&dgrmResourceName=${record.dgrmResourceName}&access-token=${Storage.getStorage("token")}`;
                         window.open(uploadUrl)
                         }}>
              {text}
            </WizButton>
          </WizDataTable.Oper>
        )
      }
    },
    {
      title: "流程XML",
      name: "resourceName",
      dataIndex: "resourceName",
      tableItem: {
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton tooltip={text}
                       onClick={() => {
                         const uploadUrl = `/api${urls.kUrlViewProcedefResource}?id=${record.id}&deploymentId=${record.deploymentId}&resourceName=${record.resourceName}&access-token=${Storage.getStorage("token")}`;
                         window.open(uploadUrl)
                       }}>
              {text}
            </WizButton>
          </WizDataTable.Oper>
        )
      }
    },
    {
      title: "状态",
      name: "suspensionState",
      dataIndex: "suspensionState",
      tableItem: {},
      dict: [
        { code: 1, codeName: "激活" },
        { code: 2, codeName: "挂起" }
      ],
      searchItem: {
        type: "select"
      },
      formItem: {
        type: "select"
      }
    },
  ];
}

const templateConfig = (e) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns:columns(e),
        searchBarProps: {
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          buttonSort:['delete'],
          buttons: [
          ],
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false
        },
        rowOperateSort:['hang'],
        rowOperateView: [
          {
            key: "hang",
            custom: true,
            params: { children: "挂起"},
            //需要根据接口数据变换按钮文字内容的传入方式
            textFormat: {
              recordKey: 'suspensionState',
              dirt: { 1: '挂起', 2: '激活' }
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "updateSuspensionState",
                apiParams: {}
              },
              formatParams: (rows, record, filters,callback) => {
                const content = `${record['suspensionState'] === 1 ? "您确定要挂起吗?" : "您确定要激活吗?"}`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      suspensionState: record['suspensionState'] === 1 ? 2 : 1,
                      id: record['id'],
                    })
                  },
                  onCancel() { }
                });
                return null
              }
            }
          },
        ],
        commonOperate: {
          delete:true,
          update:true
        }
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@listByPage`,
    }
  },
  delete:{
    path: `${componentName}/deleteProcdef`,
    payload: {
      key: `${componentName}@deleteProcdef`,
      apiParams:{cascade:true}
    }
  },
  updateSuspensionState:{
    path: `${componentName}/updateSuspensionState`,
    payload: {
      key: `${componentName}@updateSuspensionState`,
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig }
